import { GET_APPCONFIG, UPDATE_APPCONFIG } from "../../reducerTypes"

const initialState = {
  getData: {},
}

const appConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_APPCONFIG: 
    return{
      ...state,
      getData: action.payload
    }
    case UPDATE_APPCONFIG: 
    return{
      ...state,
      getData: action.payload
    }
    default:
      return state
  }
}

export default appConfigReducer
